export const SUPPORT_EMAIL = 'support@ufat.co';
export const STORE_URL = process.env.UFAT_STUDIOS_STORE_URL || '#';
export const IVR_PHONE = process.env.AWS_IVR_PHONE_NUMBER || 'Phone details pending';
